// // This function should ideally be in your 'src/utils/authHelper.js'
// export const getLoggedInUser = () => {
//   const USER_DATA_LOCAL_STORAGE_KEY = 'zTaskUserDetails';

//   try {
//     const userDataString = localStorage.getItem(USER_DATA_LOCAL_STORAGE_KEY);

//     if (!userDataString) {
//       // console.log(`authHelper: No user data found in localStorage with key "${USER_DATA_LOCAL_STORAGE_KEY}".`);
//       return null;
//     }

//     let parsedData = JSON.parse(userDataString);
//     let userData;

//     // **FIX 1: Handle if the stored data is an array**
//     // If parsedData is an array and has at least one element, assume the first element is the user object.
//     if (Array.isArray(parsedData) && parsedData.length > 0) {
//       userData = parsedData[0];
//       // console.log(`authHelper: User data was in an array, selected first element:`, userData);
//     } else if (typeof parsedData === 'object' && parsedData !== null && !Array.isArray(parsedData)) {
//       // If it's already a single object (which is the ideal way to store it)
//       userData = parsedData;
//       // console.log(`authHelper: User data was a single object:`, userData);
//     } else {
//       console.warn(
//         `authHelper: User data from key "${USER_DATA_LOCAL_STORAGE_KEY}" ` +
//         `is not a single user object or a non-empty array. Received:`,
//         parsedData
//       );
//       return null;
//     }

//     // **FIX 2: Adjust ID type check and ensure userData is valid after potential array unwrapping**
//     // The 'id' can be a number (like 1) or a string (like a UUID).
//     // The role and role.name must exist and be strings.
//     const idIsValid = (userData && (typeof userData.id === 'string' && userData.id.length > 0)) ||
//                       (userData && typeof userData.id === 'number'); // Allow number IDs

//     if (userData && idIsValid && userData.role && typeof userData.role.name === 'string') {
//       // console.log(`authHelper: Successfully retrieved and validated user data for user ID ${userData.id} (${userData.role.name}).`);
      
//       // OPTIONAL: If your application consistently expects user.id to be a string, you can convert it:
//       // if (typeof userData.id === 'number') {
//       //   userData.id = String(userData.id);
//       // }
//       return userData;
//     } else {
//       console.warn(
//         `authHelper: User data from key "${USER_DATA_LOCAL_STORAGE_KEY}" ` +
//         `is not in the expected format or is incomplete after potential array unwrapping. ` +
//         `Expected 'id' (non-empty string or number) and 'role.name' (string). Received:`,
//         userData // Log the actual userData object that failed validation
//       );
//       return null;
//     }
//   } catch (error) {
//     console.error(
//       `authHelper: Error parsing user data from localStorage (key: "${USER_DATA_LOCAL_STORAGE_KEY}"). ` +
//       `Ensure it's a valid JSON string. Error:`,
//       error
//     );
//     // Optional: Clear potentially malformed data from localStorage to prevent repeated errors on next load
//     // localStorage.removeItem(USER_DATA_LOCAL_STORAGE_KEY);
//     return null;
//   }
// };










// // This function should ideally be in your 'src/utils/authHelper.js'
// export const getLoggedInUser = () => {
//   const USER_DATA_LOCAL_STORAGE_KEY = 'zTaskUserDetails';

//   try {
//     const userDataString = localStorage.getItem(USER_DATA_LOCAL_STORAGE_KEY);

//     if (!userDataString) {
//       // console.log(`authHelper: No user data found in localStorage with key "${USER_DATA_LOCAL_STORAGE_KEY}".`);
//       return null;
//     }

//     let parsedData = JSON.parse(userDataString);
//     let userData;

//     // **FIX 1: Handle if the stored data is an array**
//     // If parsedData is an array and has at least one element, assume the first element is the user object.
//     if (Array.isArray(parsedData) && parsedData.length > 0) {
//       userData = parsedData[0];
//       // console.log(`authHelper: User data was in an array, selected first element:`, userData);
//     } else if (typeof parsedData === 'object' && parsedData !== null && !Array.isArray(parsedData)) {
//       // If it's already a single object (which is the ideal way to store it)
//       userData = parsedData;
//       // console.log(`authHelper: User data was a single object:`, userData);
//     } else {
//       console.warn(
//         `authHelper: User data from key "${USER_DATA_LOCAL_STORAGE_KEY}" ` +
//         `is not a single user object or a non-empty array. Received:`,
//         parsedData
//       );
//       return null;
//     }

//     // **FIX 2: Adjust ID type check and ensure userData is valid after potential array unwrapping**
//     // The 'id' can be a number (like 1) or a string (like a UUID).
//     // The role and role.name must exist and be strings.
//     const idIsValid = (userData && (typeof userData.id === 'string' && userData.id.length > 0)) ||
//                       (userData && typeof userData.id === 'number'); // Allow number IDs

//     if (userData && idIsValid && userData.role && typeof userData.role.name === 'string') {
//       // console.log(`authHelper: Successfully retrieved and validated user data for user ID ${userData.id} (${userData.role.name}).`);
      
//       // OPTIONAL: If your application consistently expects user.id to be a string, you can convert it:
//       // if (typeof userData.id === 'number') {
//       //   userData.id = String(userData.id);
//       // }
//       return userData;
//     } else {
//       console.warn(
//         `authHelper: User data from key "${USER_DATA_LOCAL_STORAGE_KEY}" ` +
//         `is not in the expected format or is incomplete after potential array unwrapping. ` +
//         `Expected 'id' (non-empty string or number) and 'role.name' (string). Received:`,
//         userData // Log the actual userData object that failed validation
//       );
//       return null;
//     }
//   } catch (error) {
//     console.error(
//       `authHelper: Error parsing user data from localStorage (key: "${USER_DATA_LOCAL_STORAGE_KEY}"). ` +
//       `Ensure it's a valid JSON string. Error:`,
//       error
//     );
//     // Optional: Clear potentially malformed data from localStorage to prevent repeated errors on next load
//     // localStorage.removeItem(USER_DATA_LOCAL_STORAGE_KEY);
//     return null;
//   }
// };









// Retrieve authentication token from localStorage
export const getToken = () => {
  const token = localStorage.getItem("zTaskAuthToken");
  if (!token) {
    console.warn("Authentication token 'zTaskAuthToken' not found in local storage.");
    return null;
  }
  return token;
};

// Retrieve currently logged-in user data from localStorage
export const getLoggedInUser = () => {
  const USER_DATA_LOCAL_STORAGE_KEY = 'zTaskUserDetails';

  try {
    const userDataString = localStorage.getItem(USER_DATA_LOCAL_STORAGE_KEY);
    if (!userDataString) {
      return null;
    }

    let parsedData = JSON.parse(userDataString);
    let userData;

    if (Array.isArray(parsedData) && parsedData.length > 0) {
      userData = parsedData[0];
    } else if (typeof parsedData === 'object' && parsedData !== null) {
      userData = parsedData;
    } else {
      console.warn(
        `authHelper: User data from key "${USER_DATA_LOCAL_STORAGE_KEY}" is not valid:`,
        parsedData
      );
      return null;
    }

    const idIsValid = (typeof userData.id === 'string' && userData.id.length > 0) ||
                      typeof userData.id === 'number';

    if (userData && idIsValid && userData.role && typeof userData.role.name === 'string') {
      return userData;
    } else {
      console.warn(
        `authHelper: User data format incomplete or invalid. Received:`,
        userData
      );
      return null;
    }
  } catch (error) {
    console.error(
      `authHelper: Error parsing user data from localStorage (key: "${USER_DATA_LOCAL_STORAGE_KEY}").`,
      error
    );
    return null;
  }
};
